import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';

export default class CurrentTrack extends Component {
  static defaultProps = {
    'type': 'Soundcloud',
    'title': '',
    'image_url': '/assets/article_summary_image.png'
  };

  render() {
    return (
      <div className={css(styles.container)}>
        <div className={css(styles.cover)}>
          <img src={this.props.image_url} className={css(styles.image)} />
        </div>
        <div className={css(styles.info)}>
          {
            // <div className={css(styles.track_source)}>Now playing{ this.props.type ? ` from ${this.props.type}` : false}</div>
          }
          <div className={css(styles.track_title)}>{this.props.title}</div>
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    marginLeft: 40,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: Theme.player.current_track.width,
  },
  cover: {
    width: 40,
  },
  image: {
    width: 40,
    height: 40,
  },
  info: {
    flex: 4,
  },
  info: {
    paddingLeft: 10,
    fontFamily: Theme.fontFamily,
    fontSize: 12,
    lineHeight: '16px',
    fontColor: Theme.dark_grey,
  },
  track_source: {
    fontWeight: 'normal'
  },
  track_title: {
    fontWeight: 600
  }
})



// WEBPACK FOOTER //
// ./src/components/CurrentTrack/index.js